<!-- eslint-disable -->
<template>
  <svg
    class="kc-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 425">
    <line
      x1="150"
      y1="200"
      x2="150"
      y2="350" />
    <line
      x1="225"
      y1="400"
      x2="225"
      y2="350" />
    <line
      x1="75"
      y1="350"
      x2="75"
      y2="400" />
    <circle
      cx="150"
      cy="126.4"
      r="25" />
    <line
      x1="75"
      y1="325"
      x2="75"
      y2="200" />
    <path
      d="M175,325h100s0-25,0-25v-6.79c0-8.39-1.03-16.77-3.38-24.82-4.26-14.61-12.17-27.56-24.01-38.52-2.81-2.6-5.49-5.33-8.25-7.97-6.46-6.18-14.61-13.52-14.58-22.65,.09-25.49,.85-51-1.05-76.47-.03-.36-.05-.72-.08-1.07-3.38-43.6-31.82-81.39-72.89-96.43-.25-.09-.5-.18-.75-.27-.25,.09-.5,.18-.75,.27-41.06,15.04-69.51,52.83-72.89,96.43-.03,.36-.06,.72-.08,1.07-1.91,25.47-1.15,50.98-1.05,76.47,.03,9.14-8.12,16.47-14.58,22.65-2.76,2.64-5.45,5.37-8.25,7.97-11.84,10.96-19.75,23.91-24.01,38.52-2.35,8.05-3.38,16.43-3.38,24.82v6.79s0,25,0,25h125" />
    <line
      x1="225"
      y1="325"
      x2="225"
      y2="200" />
    <line
      x1="150"
      y1="400"
      x2="150"
      y2="375" />
  </svg>
</template>
